import icons from "../../../../Data/icons";
import classes from "./changepassword.module.css";

const ChangePasswordForm = ({setError,error, setOldPassword ,setNewPassword, setConfirmPassword}) => {
  const handleOldPassword =(e)=>{
 setOldPassword(e.target.value)
  }
  const handleNewPassword =(e)=>{
setNewPassword(e.target.value)
  }
  const handleConfirmPassword =(e)=>{
setConfirmPassword(e.target.value)
  }
 
  const Password =icons.password
  return (
    <div className={classes.container}>
      <div className={classes.formCard}>
        <h1 className={classes.headTitle}>معلومات كلمة المرور</h1>
        <div className={classes.formGrid}>
          <div className={classes.formCol}>
          <div className={classes.iconInput}>
            <Password />
          </div>
            <label htmlFor="currentpassword">كلمة المرور الحالية</label>
            <input className={classes.inputCustom}  placeholder="ادخل كلمة المرور الحالية" type="password" onChange={handleOldPassword} />
          </div>
          <div className={classes.formCol}>
          <div className={classes.iconInput}>
            <Password />
          </div>
            <label htmlFor="currentpassword">كلمة المرور الجديدة</label>
            <input className={classes.inputCustom}  placeholder="ادخل كلمة المرور الجديدة" type="password" onChange={handleNewPassword} />
          </div>
          <div className={classes.formCol}>
         
          <div className={classes.iconInput}>
            <Password />
          </div>
          
            <label htmlFor="currentpassword">تأكيد كلمة المرور </label>
            <input className={classes.inputCustom} placeholder="ادخل كلمة المرور مره اخري" type="password" onChange={handleConfirmPassword} />
            {error && <p style={{ color: 'red' }}>{error}</p>}
          </div>
          
        </div>
      </div>
    </div>
  );
};

export default ChangePasswordForm;
